<div class="pg-mobile-side slideout-menu slideout-menu-left" id="pgLayoutMenuContainer">
  <div class="row p-4">
    <shared-geolocation
      *ngIf="(deviceValue | async) === DTypes.Mobile || (deviceValue | async) === DTypes.Tablet">
    </shared-geolocation>
  </div>
  <div class="row">
    <shared-main-menu [Device]="DTypes.Mobile"></shared-main-menu>
  </div>
  <div class="row">
    <shared-footer-menu [Device]="DTypes.Mobile"></shared-footer-menu>
  </div>
  <div class="row">
    <div class="account-mobile-menu__button" (click)="onSignUp()" *ngIf="!AccountMenuUser">
      <div class="grid align-items-center justify-content-center">
        <span class="text">Регистрация</span>
      </div>
    </div>
  </div>
</div>
